import { render } from "./reservation-form.vue?vue&type=template&id=4c701662"
import script from "./reservation-form.vue?vue&type=script&lang=js"
export * from "./reservation-form.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/reservation-form.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c701662"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c701662', __exports__)) {
    api.reload('4c701662', __exports__)
  }
  
  module.hot.accept("./reservation-form.vue?vue&type=template&id=4c701662", () => {
    api.rerender('4c701662', render)
  })

}


export default __exports__